var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page403"},[_c('div',{staticClass:"content"},[_c('span',{staticClass:"icon-auth"}),_c('br'),_c('span',[_vm._v("暂无权限")])])])
}]

export { render, staticRenderFns }